module.exports = __webpack_public_path__ + "static/media/phoneMockup.93790d45.png";